const STORAGE_KEY = 'cookiesShowed'
const HIDDEN_CLASS = 'cookie-notification_hidden'
const INIT_ATTR = 'data-cookie-notification-initialized'

/**
 * Проверяет доступность `localStorage` в текущем окружении.
 * @return {boolean} `true`, если `localStorage` доступен и работает.
 */
const canUseStorage = (): boolean => {
  try {
    const testKey = '__cookie_notice_test__'
    window.localStorage.setItem(testKey, '1')
    window.localStorage.removeItem(testKey)
    return true
  } catch (error) {
    console.error('LocalStorage is not available:', error)
    return false
  }
}

/**
 * Определяет, было ли уведомление уже показано пользователю.
 * @return {boolean} `true`, если флаг показа сохранен в `localStorage`.
 */
const isShown = (): boolean => {
  if (!canUseStorage()) {
    return false
  }

  return Boolean(window.localStorage.getItem(STORAGE_KEY))
}

/**
 * Ставит флаг, что уведомление уже показано.
 */
const markShown = (): void => {
  if (!canUseStorage()) {
    return
  }

  window.localStorage.setItem(STORAGE_KEY, 'true')
}

/**
 * Показывает уведомление и обновляет доступность.
 * @param {HTMLElement} node DOM-узел уведомления.
 */
const show = (node: HTMLElement): void => {
  node.classList.remove(HIDDEN_CLASS)
  node.setAttribute('aria-hidden', 'false')
}

/**
 * Скрывает уведомление и обновляет доступность.
 * @param {HTMLElement} node DOM-узел уведомления.
 */
const hide = (node: HTMLElement): void => {
  node.classList.add(HIDDEN_CLASS)
  node.setAttribute('aria-hidden', 'true')
}

/**
 * Инициализирует один DOM-узел уведомления.
 * @param {HTMLElement} node DOM-узел уведомления.
 */
const initNode = (node: HTMLElement): void => {
  if (node.hasAttribute(INIT_ATTR)) {
    return
  }

  node.setAttribute(INIT_ATTR, 'true')

  if (isShown()) {
    hide(node)
    return
  }

  show(node)

  const closeButtons = node.querySelectorAll<HTMLElement>(
    '[data-cookie-notification-close]'
  )
  closeButtons.forEach((button) => {
    button.addEventListener('click', () => {
      markShown()
      hide(node)
    })
  })
}

/**
 * Инициализирует уведомление о cookie на странице.
 */
export function initCookie(): void {
  const node = document.querySelector<HTMLElement>('[data-cookie-notification]')
  if (node) {
    initNode(node)
  }
}
